import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=0600bfdc&"
import script from "./ImageDropzone.vue?vue&type=script&lang=js&"
export * from "./ImageDropzone.vue?vue&type=script&lang=js&"
import style0 from "./ImageDropzone.vue?vue&type=style&index=0&id=0600bfdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports